import 'datejs';
import calendar from './../util/calendar';

export default {
  init() {

  },
  finalize() {

    // Select number of visitors
    $('.group-visiting .visiting-selection').on('click', function() {
      $('.group-visiting .visiting-selection').removeClass('selected');
      $(this).addClass('selected');

      if ($('.tr-calendar-week-day.selected').length > 0) {
        calendarDaySelected();
      }
      
      checkPageOneReady();

      // Ticket delegation
      setTicketsToAssign();
    });

    calendar.instantiate();

    if ($('#success-page').length == 0) {
      calendar.populateCalendarMonth($('.tr-calendar-wrap').data('month-offset'));
    } else {
      const lang = $('#success-page').data('lang-switch');

      if (lang != $('html').attr('lang') && lang != '') {
        // We need to switch
        const urlGoto = $('.links-language-switcher .wpml-ls-item:not(.wpml-ls-current-language) a').attr('href') + window.location.search;

        window.location.replace(urlGoto);
      }
    }

    // Click a calendar day
    $('.tr-calendar-wrap .tr-calendar-body .tr-calendar-week-day').on('click', function() {
      if ($(this).data('available')) {
        const $this_ = $(this);

        $('.tr-calendar-wrap .tr-calendar-body .tr-calendar-week-day.selected').each(function() {
          if ($(this).get()[0] != $this_.get()[0]) {
            $(this).removeClass('selected');
          }
        });

        $(this).toggleClass('selected');

        if ($(this).hasClass('selected')) {
          const fullDate = $(this).data('full-date');
          $('.tr-calendar-wrap').data('chosen-date', fullDate);
          $('input[name="tr_date_selection"]').val(fullDate);

          calendarDaySelected();
        } else {
          $('.tr-calendar-wrap').data('chosen-date', '');
        }
      }

      checkPageOneReady();
    });

    function calendarDaySelected() {
      const dateSelected = $('.tr-calendar-wrap').data('chosen-date');
      const $visitorsQuantity = $('.group-visiting .visiting-selection.selected');

      if ($visitorsQuantity.length > 0) {
        const visitorsQuantity = $visitorsQuantity.data('visiting');
        const dateSplit = dateSelected.split('-');

        $('.group-timeslots-loading').removeClass('d-none');
        $('.group-timeslots').html('');

        // Run an API call to retrieve all the timeslots for this date.
        $.ajax({
          url: '/wp-json/booking/get-all-timeslots',
          method: 'GET',
          data: {
            day: dateSplit[0],
            month: dateSplit[1],
            year: dateSplit[2],
          },
        }).done(function(allData) {
          // Run an API call to determine the timeslots available for this.
          $.ajax({
            url: '/wp-json/booking/get-available-timeslots',
            method: 'GET',
            data: {
              day: dateSplit[0],
              month: dateSplit[1],
              year: dateSplit[2],
              includePlacesAvailable: true,
            },
          }).done(function(availableData) {

            // Clear the timeslots element
            $('.group-timeslots').html('');
            $('.group-timeslots-loading').addClass('d-none');

            // Create a button for each timeslot
            allData.forEach((timeslot) => {
              const $timeslotButton = $(`<button type="button" class="timeslot-choose">${timeslot}</button>`);
              $timeslotButton.appendTo($('.group-timeslots'));

              // Check if this timeslot appears as an available timeslot
              var available = false;

              availableData.forEach((availableTimeslot) => {
                // Check this timeslot appears as available
                if (availableTimeslot[0] == timeslot) {
                  // Check the quantity
                  if ($('.visiting-selection.selected').data('visiting') <= availableTimeslot[1]) {
                    available = true;
                  }
                }
              });

              if (available) {

                // Create a trigger for this selection
                $timeslotButton.on('click', function() {
                  $('.group-timeslots .timeslot-choose').removeClass('selected');
                  $(this).addClass('selected');
                  checkPageOneReady();
                });

              } else {
                
                // Not available, disable
                $timeslotButton.addClass('disable');

              }

            });

          });
        });
      }

      checkPageOneReady();
    }

    //// Ticket delegation
    // Set the 'tickets to assign' based on chosen tickets
    function setTicketsToAssign() {
      const quantityToAssign = $('.visiting-selection.selected').data('visiting');

      var quantityAssigned = 0;
      $('.assign-box').each(function() {
        quantityAssigned += $(this).find('.box-quantifier').data('quantity') * $(this).data('default-quantity');
      });

      if (quantityAssigned > quantityToAssign) {
        // Too many have been assigned. Just clear them all and restart.
        quantityAssigned = 0;
        $('.assign-box').each(function() {
          $(this).find('.box-quantifier').data('quantity', 0);
          $(this).find('.box-quantifier .quantifier-total').html('0');
        });
      }
      
      const quantityRemaining = quantityToAssign - quantityAssigned;

      $('.prompt-remaining .prompt-remaining-quantity').html(quantityRemaining);

      // Plural/Single
      if (quantityRemaining == 1) {
        $('.prompt-remaining .prompt-remaining-ticket-single').removeClass('d-none');
        $('.prompt-remaining .prompt-remaining-ticket-plural').addClass('d-none');
      } else {
        $('.prompt-remaining .prompt-remaining-ticket-single').addClass('d-none');
        $('.prompt-remaining .prompt-remaining-ticket-plural').removeClass('d-none');
      }
    }

    // Increase/Decrease ticket delegation
    $('.assign-box .quantifier-less').on('click', function() {
      const defaultQuantity = $(this).parents('.assign-box').data('default-quantity');
      const quantity = $(this).parent().data('quantity');

      if (quantity > 0) {
        $(this).parent().data('quantity', quantity - 1);
        $(this).siblings('.quantifier-total').html(quantity - 1);
        setTicketsToAssign();
        checkPageOneReady();
      }
    });
    
    $('.assign-box .quantifier-more').on('click', function() {
      // Check that there are enough tickets to assign
      const ticketsToAssign = parseInt($('.prompt-remaining .prompt-remaining-quantity').html());

      const defaultQuantity = $(this).parents('.assign-box').data('default-quantity');
      const quantity = $(this).parent().data('quantity');

      if (ticketsToAssign - defaultQuantity >= 0) {
        $(this).parent().data('quantity', quantity + 1);
        $(this).siblings('.quantifier-total').html(quantity + 1);
        setTicketsToAssign();
        checkPageOneReady();
      }
    });

    // Simply check if all the fields on page one have been filled and enables/disables confirm button respectively
    function checkPageOneReady() {
      var allTicketsDelegated = $('.prompt-remaining-quantity').html() == '0';

      $('.bat-confirm.bat-confirm-one').prop('disabled', !($('.visiting-selection.selected').length > 0 && $('.tr-calendar-week-day.selected').length > 0 && $('.timeslot-choose.selected').length > 0 && allTicketsDelegated));
    }

    // Go to screen 2 (Confirm on page 1)
    $('.bat-confirm.bat-confirm-one').on('click', function() {
      if (!$(this).prop('disabled')) { // Probably a redundant query

        // Update booking summary
        const numberVisiting = $('.visiting-selection.selected').data('visiting');
        var ticketTypes = [];
        var total = 0;

        const isFree = $('.tr-calendar-week-day.selected').hasClass('free');

        $('.group-ticket-assign-box .assign-box').each(function() {
          const quantity = $(this).find('.box-quantifier').data('quantity');
          const priceRaw = isFree ? 0 : $(this).data('price') * quantity;
          const price = isFree ? 0 : (Math.round(priceRaw * 100) / 100).toFixed(2);
          const name = $(this).data('name');
          const slug = $(this).data('slug');

          if (quantity > 0) {
            ticketTypes.push({
              name: name,
              slug: slug,
              quantity: quantity,
              price: price,
            });

            total += priceRaw;
          }
        });

        total = (Math.round(total * 100) / 100).toFixed(2);

        const visitDate = $('.tr-calendar-wrap').data('chosen-date').split('-');
        const visitTime = $('.timeslot-choose.selected').html();
        const date = new Date(visitDate[2] + '-' + visitDate[1] + '-' + visitDate[0] + ' ' + visitTime);
        const dateFriendly = date.format('j, F d, Y');
        const visitTimePeriod = visitTime + ' - ' + (date.getHours() + 1) + ':' + date.getMinutes().toString().padStart(2, '0');
        
        $('#prop-number-visiting').html(numberVisiting);

        ticketTypes.forEach((ticketType) => {
          const $ticketTypeElement = $(`<div class="property-type"><div class="type-name">${ticketType.quantity} x ${ticketType.name}</div><div class="type-value">£${ticketType.price}</div></div>`);

          $('#prop-visitor-types').append($ticketTypeElement);
        });

        $('#prop-visitor-types').data('visitor-types', JSON.stringify(ticketTypes));

        $('#prop-visit-date').html(dateFriendly);
        $('#prop-visit-time').html(visitTimePeriod);
        $('#prop-visit-total').html(`£${total}`);

        // Hide screen 1
        $('.bat-screen-one').addClass('d-none');

        // Show screen 2
        $('.bat-screen-two').removeClass('d-none');

        // Go to top
        window.scrollTo(0, $('a[name="form-start"]').offset().top - 100);

      }
    });

    // Confirm final button clicked
    $('.bat-confirm.bat-confirm-two').on('click', function() {
      
      const visitDate = $('.tr-calendar-wrap').data('chosen-date').split('-');

      // 1. Pack all the data into a cookie
      const data = {
        visitorTypes: JSON.parse($('#prop-visitor-types').data('visitor-types')),
        date: (new Date(visitDate[2] + '-' + visitDate[1] + '-' + visitDate[0])).getTime(),
        time: $('.timeslot-choose.selected').html(),
        additionalInfo: $('.additional-info').prop('value'),
      };

      const dataFriendly = JSON.stringify(data);

      const date = new Date();
      date.setTime(date.getTime() + (24 * 60 * 60 * 1000));

      const cookieExpiration = date.toUTCString();

      document.cookie = `booking_data=${dataFriendly};expires=${cookieExpiration};path=/`;

      const lang = $('html').attr('lang');
      document.cookie = `lang=${lang};expires=${cookieExpiration};path=/`;

      // 2. Run a query to add the booking product to the basket
      $.ajax({
        url: '/wp-json/booking/add-product-to-basket',
        method: 'GET',
      }).done(function(e) {

        // 3. Head to the checkout (URL sent by endpoint)
        window.location.replace(e);

      });

    });

  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateBookATour.js